import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  SearchInput,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'shared-portal-components-v2';

import type { ExternalUserStatusFilter } from '@/types/external-users.types';

const STATUS_FILTER_OPTIONS: ExternalUserStatusFilter[] = [
  'All',
  'Active',
  'Inactive',
  'Unregistered',
];

function isStatusFilter(value: string): value is ExternalUserStatusFilter {
  return (STATUS_FILTER_OPTIONS as string[]).includes(value);
}

interface ExternalUsersControlsProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearchClear: () => void;
  deptOrgFilter: string;
  deptOrgOptions: string[];
  onDeptOrgFilterChange: (value: string) => void;
  statusFilter: ExternalUserStatusFilter;
  onStatusFilterChange: (value: ExternalUserStatusFilter) => void;
}

function ExternalUsersControls({
  searchValue,
  onSearchChange,
  onSearchClear,
  deptOrgFilter,
  deptOrgOptions,
  onDeptOrgFilterChange,
  statusFilter,
  onStatusFilterChange,
}: ExternalUsersControlsProps): React.ReactElement {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="relative flex-1 max-w-md">
        <SearchInput
          value={searchValue}
          className="flex-1 h-11"
          onChange={onSearchChange}
          onClear={onSearchClear}
          placeholder="Search external users"
        />
      </div>

      <div className="flex items-center gap-4">
        <Select value={deptOrgFilter} onValueChange={onDeptOrgFilterChange}>
          <SelectTrigger className="w-[190px]" aria-label="Filter by department or organization">
            <SelectValue placeholder="Dept / Org" />
            <ChevronDown className="h-4 w-4 text-muted-foreground" aria-hidden />
          </SelectTrigger>
          <SelectContent>
            {deptOrgOptions.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select
          value={statusFilter}
          onValueChange={(value) => {
            if (isStatusFilter(value)) {
              onStatusFilterChange(value);
            }
          }}
        >
          <SelectTrigger className="w-[160px]" aria-label="Filter by status">
            <SelectValue placeholder="Status" />
            <ChevronDown className="h-4 w-4 text-muted-foreground" aria-hidden />
          </SelectTrigger>
          <SelectContent>
            {STATUS_FILTER_OPTIONS.map((option) => (
              <SelectItem key={option} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default ExternalUsersControls;
